import { Stack, Tooltip, IconButton } from '@mui/material';
import { ReportsProjectFilter } from 'src/@types/project';
import { Range } from 'src/components/date-range-picker';
import { Teammate } from 'src/@types/teammates';
import { ReportsGeographyFilter } from 'src/@types/geographyFilters';
import Iconify from 'src/components/iconify/Iconify';
import { ReportsTeamFilter } from 'src/@types/team';
import { TOutreachType } from 'src/@types/outreachType';
import ActivityFeedExportModal from './ActivityFeedExportModal';

type Props = {
  filteredOutreachType: TOutreachType | null;
  filteredUser: Teammate | Partial<Teammate> | null;
  filteredProject: ReportsProjectFilter | null;
  filteredDateRange: Range | null;
  filteredCounty: ReportsGeographyFilter | null;
  filteredPrecinct: ReportsGeographyFilter | null;
  filteredCongressionalDistrict: ReportsGeographyFilter | null;
  filteredStateHouseDistrict: ReportsGeographyFilter | null;
  filteredStateSenateDistrict: ReportsGeographyFilter | null;
  filteredDma: ReportsGeographyFilter | null;
  filteredTeam: ReportsTeamFilter | null;
};

export default function ActivityFeedExport({
  filteredOutreachType,
  filteredProject,
  filteredUser,
  filteredDateRange,
  filteredCounty,
  filteredPrecinct,
  filteredCongressionalDistrict,
  filteredStateHouseDistrict,
  filteredStateSenateDistrict,
  filteredDma,
  filteredTeam,
}: Props) {
  return (
    <ActivityFeedExportModal
      exportParams={{
        project_id: filteredProject?.id,
        user_id: filteredUser?.id,
        start_datetime: filteredDateRange?.startDate?.toUTCString(),
        end_datetime: filteredDateRange?.endDate?.toUTCString(),
        county_name: filteredCounty?.id,
        precinct_id: filteredPrecinct?.id,
        congressional_district: filteredCongressionalDistrict?.id,
        state_leg_upper_district: filteredStateSenateDistrict?.id,
        state_leg_lower_district: filteredStateHouseDistrict?.id,
        dma_name: filteredDma?.id,
        team_id: filteredTeam?.id,
        outreach_type: filteredOutreachType || undefined,
      }}
    >
      {({ openExportModal }) => (
        <Stack>
          <Tooltip title="Export activity feed" arrow>
            <span>
              <IconButton onClick={openExportModal}>
                <Iconify icon="eva:cloud-download-fill" width={24} />
              </IconButton>
            </span>
          </Tooltip>
        </Stack>
      )}
    </ActivityFeedExportModal>
  );
}
